import { map, withLatestFrom, filter } from 'rxjs/operators';
import { path } from '@cbridge-utils/redux';
import { IEpic } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { IBaseApiDependencySegment } from '@cbridge-packages/api-base';
import { AuthAction } from '../auth.action';
import { authStoreSelector } from '../auth.selector';

type IState =
  & IGetSelectorStateType<typeof authStoreSelector>;

type IDependencies = IBaseApiDependencySegment;

export const logoutAuthEventEpic: IEpic<IState, IDependencies> = (_action$, state$, dependencies) => {
  return dependencies.api.logoutEvent$().pipe(
    withLatestFrom(state$),
    filter(([, state]) => !path(authStoreSelector).isLoggingOut()(state)),
    map(() => {
      return AuthAction.logout();
    }),
  );
};
